module.exports = __webpack_public_path__ + "img/managment-services-marinholdings.c7a2786c.jpg";